import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Remove } from '../icons';
import { CustomTag } from '../../assets/styles/components/tag.syled';
import { Button, Tooltip } from '../Ant';
import { findTabbableAfter } from '../../helpers/tabbableHelper';

interface TagProps {
  disabled?: boolean;
  text: string;
  removeTag: () => void;
  classname?: string;
  icon?: React.ReactNode;
  disabledInfoMessage?: string;
}

const Tag: React.FC<TagProps> = ({
  text,
  removeTag,
  disabled,
  classname,
  icon,
  disabledInfoMessage,
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);

  if (!visible) return null;
  const handleRemove = (event: MouseEvent<HTMLElement>) => {
    // The tag unmounts with its button, so focus moves on first rather than dropping to the page.
    findTabbableAfter(event.currentTarget)?.focus();
    setVisible(false);
    removeTag();
  };
  const renderCloseButton = () => {
    return (
      <Button
        aria-label={`${t('common:clear')} ${text}`}
        disabled={disabled}
        onClick={handleRemove}
        icon={icon || <Remove />}
        className="tag-close-btn"
        data-testid="tag-close-btn"
      />
    );
  };
  return (
    <CustomTag data-testid={`tag-${text}`} className={classname}>
      <span className="tag-text">{text}</span>
      {disabled && disabledInfoMessage ? (
        <Tooltip title={disabledInfoMessage} placement="top" arrow={false}>
          {renderCloseButton()}
        </Tooltip>
      ) : (
        renderCloseButton()
      )}
    </CustomTag>
  );
};

export default Tag;
